"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.pageHasSharedStore = exports.pageHasSharedClient = exports.pageHasOmniContent = exports.default = void 0;
var _apollo = require("../apollo");
var _initSharedStore = _interopRequireDefault(require("../sharedState/initSharedStore"));
/* eslint-disable no-underscore-dangle */
function initState(_ref) {
  var apiUrl = _ref.apiUrl,
    _ref$persistSharedSta = _ref.persistSharedState,
    persistSharedState = _ref$persistSharedSta === void 0 ? false : _ref$persistSharedSta,
    _ref$storeConfig = _ref.storeConfig,
    storeConfig = _ref$storeConfig === void 0 ? {} : _ref$storeConfig,
    _ref$cacheConfig = _ref.cacheConfig,
    cacheConfig = _ref$cacheConfig === void 0 ? {} : _ref$cacheConfig;
  var store = (0, _initSharedStore.default)(Object.assign({}, storeConfig, {
    persistSharedState: persistSharedState
  }));
  var client = (0, _apollo.createClient)({
    uri: apiUrl,
    store: store,
    cacheOptions: cacheConfig
  });
  return {
    client: client,
    // $FlowFixMe: Confused by immutable-js
    store: store
  };
}
var pageHasSharedStore = exports.pageHasSharedStore = function pageHasSharedStore() {
  return typeof window !== 'undefined' && window.nobia != null && window.nobia.sharedStore != null;
};
var pageHasSharedClient = exports.pageHasSharedClient = function pageHasSharedClient() {
  return typeof window !== 'undefined' && window.nobia != null && window.nobia.sharedClient != null;
};
var pageHasOmniContent = exports.pageHasOmniContent = function pageHasOmniContent() {
  return typeof window !== 'undefined' && (window.zeus != null || window.__NEXT_DATA__ != null && window.__NEXT_DATA__.props != null);
};
var _default = exports.default = initState;